import DragAndDropAttachment from "./DragAndDropAttachment";

export default DragAndDropAttachment;
